import { Sync } from '@mui/icons-material';
import { CircularProgress, IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useAlert } from '../../../api/alert-api/AlertAPI';
import { alertError } from '../../../api/error-api/ErrorAPI';

/**
 * Manually start a sync job.
 * @param onSync - group sync function
 * @param groupId - group identifier
 * @constructor
 */
export const ManualGroupSyncButton = function (onSync: (groupId: string) => Promise<void>, groupId: string) {
  const [loading, setLoading] = useState<boolean>(false);

  const alert = useAlert();

  /**
   * Manually start group sync
   */
  const performManualGroupSync = () => {
    setLoading(true);

    onSync(groupId)
      .then(() => {
        alert?.alert('Began manual group sync', 'success');
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        throw alertError(alert, 'Failed to begin manual group sync', err);
      });
  };

  return (
    <IconButton
      className="bg-blue-500 hover:bg-blue-400 mx-auto"
      onClick={performManualGroupSync}
    >
      {/*  Display loading icon when awaiting api call success */}
      {loading
        ? (<CircularProgress size="1.5rem" className="text-white" />)
        : (<Sync className="text-white" />)}
    </IconButton>
  );
};
